import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Row, Col, Breadcrumb, Tag, Input, Pagination, Icon, Card, Button, Table, Switch, Radio, Tooltip, Popconfirm, Message, Form } from 'antd';
import styles from './index.less';
import { Product, Filter } from "../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
// import { EditableCell } from '../../../components';
import dumpImage from "./dump.png";
import { s3Host } from "../../../utils";
import { Cascader } from '../../../components';

const MNT = '₮';
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;

console.log({ FormItem });

class ProductList extends PureComponent {
  state = {
    selectedRowsId: null,
  }
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.refresh();
  }

  onCellChange = (value, record) => {
    this.props.updateQuantity({
      body: {
        id: record.id,
        quantity: value,
      },
    });
  }

  handleTableChange = async (page, pageSize, string, key) => {
    await this.props.filterChange({
      ...this.props.filter,
      offset: page - 1,
      limit: pageSize,
      [key]: string,
    });
    this.refresh();
  }

  handleDelete = async (id) => {
    await this.props.productDelete({ body: { id } });
    Message.success('Барааг амжилттай устгалаа');
    this.refresh();
  }

  handleDeleteAll = async () => {
    console.log('values', this.state.selectedRowsId);
    if (this.state.selectedRowsId && this.state.selectedRowsId.length > 0) {
      // eslint-disable-next-line guard-for-in
      for (const id in this.state.selectedRowsId) {
        await this.props.productDelete({ body: { id: this.state.selectedRowsId[id].id } });
      }
      Message.success('Барааг амжилттай устгалаа');
      this.refresh();
    }
  }

  exportExcel = () => {
    this.props.exportExcel();
  }

  refresh = () => {
    this.props.products({ body: this.props.filter });
  }

  columns = [
    {
      title: '',
      dataIndex: 'inactive',
      key: 'inactive',
      width: '20px',
      align: 'center',
      render: (text, record) => (
        <div>{record.inactive === true ? <Tooltip placement="top" title="Идэвхгүй бараа"><span className={styles.statusInavtive} /></Tooltip> : <Tooltip placement="top" title="Идэвхтэй бараа"><span className={styles.statusActive} /></Tooltip> }</div>
      ),
    }, {
      title: 'Зураг',
      dataIndex: 'image',
      width: '140px',
      key: 'image',
      align: 'center',
      render: (text, record) => (
        <Link to={`products/edit/${record.id}`}><img src={record.dump_image === null ? dumpImage : `${s3Host}${record.dump_image}`} alt={record.title} width="70px" className={styles.productImage} /></Link>
      ),
    }, {
      title: 'Барааны нэр',
      dataIndex: 'title',
      width: '350px',
      key: 'title',
      render: (text, record) => (
        <Link to={`products/edit/${record.id}`} className={styles.productTitle}>{record.title}</Link>
      ),
    }, {
      title: 'Категори',
      dataIndex: 'relation.alias',
      width: '200px',
      key: 'relation.alias',
      render: (text, record) => (
        <span style={{ color: '#666' }}>{record.relation.alias}</span>
      ),
    }, {
      title: 'Бар код',
      dataIndex: 'barcode',
      width: '200px',
      key: 'barcode',
      render: (text, record) => (
        <span style={{ color: '#888' }}>{record.barcode}</span>
      ),
    }, {
      title: 'Үнэ',
      dataIndex: 'price',
      width: '200px',
      key: 'price',
      align: 'right',
      render: (text, record) => (
        <div style={{ color: '#777', float: 'right' }}>{record.price.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} {MNT}</div>
      ),
    }, {
      title: 'Х/үнэ',
      dataIndex: 'discount_price',
      width: '150px',
      key: 'discount_price',
      align: 'right',
      render: (text, record) => (
        (record.discount_price) ?
          (<div style={{ float: 'right' }}>{record.discount_price.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} {MNT}</div>) :
          null
      ),
    }, {
      title: 'Үлдэгдэл',
      dataIndex: 'quantity',
      width: '180px',
      key: 'quantity',
      align: 'center',
      render: (text, record) => (
        <div>{record.quantity < 5 ? <Tag color="#ff5500">{record.quantity}</Tag> : <Tag color="#87d068">{record.quantity}</Tag> && record.quantity < 20 ? <Tag color="#faad14">{record.quantity}</Tag> : <Tag color="#87d068">{record.quantity}</Tag>}</div>
      ),
    }, {
      title: 'Эрэмбэ',
      dataIndex: 'position',
      width: '170px',
      key: 'position',
      align: 'right',
    }, {
      title: 'Үйлдэл',
      width: '160px',
      key: 'action',
      render: (text, record) => (
        <Button.Group size="small">
          <Button>
            <Link to={`/products/edit/${record.id}`}>
              <Icon type="edit" />
            </Link>
          </Button>
          <Popconfirm
            title="Та уг Барааг устгахдаа итгэлтэй байна уу？"
            okText="Тийм"
            cancelText="Үгүй"
            onConfirm={() => { this.handleDelete(record.id); }}
          >
            <Button>
              <Icon type="delete" />
            </Button>
          </Popconfirm>

        </Button.Group>
      ),
    }];

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log('selectedRowKeys', Object.values(selectedRows));
      this.setState({
        selectedRowsId: Object.values(selectedRows),
      }, () => {
        console.log(this.state.selectedRowsId, 'selectedRowsId');
      });
    },
  }

  render() {
    const { productList } = this.props;
    const breadcrumb = (
      <Col span={24}>
        <div className={styles.pageTop}>
          <Col span={3}>
            <Breadcrumb className={styles.Topbread}>
              <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Бараа</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={21} style={{ marginTop: 3 }}>
            <div className={styles.TopGuide}>
              <ul className={styles.productGuide}>
                <li> Нийт бараа: <strong>{this.props.productList.total}</strong></li>
              </ul>
              <ul className={styles.quantityStatus}>
                <li><span className={styles.guideRed} /> Маш бага</li>
                <li><span className={styles.guideYellow} /> Цөөн үлдсэн</li>
                <li><span className={styles.guideGreen} /> Хангалттай</li>
              </ul>
              <Link to="/products/create" className={styles.createBtn}>
                <Button icon="plus" type="primary" size="small" style={{ fontSize: 13 }}>Бараа нэмэх</Button>
              </Link>
              <Link to="/products/upload" className={styles.uploadBtn}>
                <Button icon="upload" type="primary" size="small" style={{ fontSize: 13 }}>Зураг хуулах</Button>
              </Link>
              <Link to="/products/excel" className={styles.uploadBtn}>
                <Button icon="upload" type="primary" size="small" style={{ fontSize: 13 }}>Excel хуулах</Button>
              </Link>
              <Button
                icon="file"
                type="primary"
                size="small"
                style={{ fontSize: 13, marginLeft: 4 }}
                loading={this.props.excel.isLoading}
                onClick={() => this.exportExcel()}
              >
                Excel татах
              </Button>
              {/* <Link to="/products/excel" className={styles.uploadBtn}>
                <Button icon="upload" type="primary" size="small" style={{ fontSize: 13 }}>Excel хуулах</Button>
              </Link> */}
            </div>
          </Col>
        </div>
      </Col>);

    return (
      <PageHeaderLayout
        style={{ padding: '0' }}
        top
        content={breadcrumb}
      >
        <Card bordered>
          <Row type="flex" justify="start">
            <Col span={24}>
              <Col span={12}>
                <span className={styles.pageHeading}>Бараа</span>
              </Col>
              <Col span={12}>
                {
                  this.state.selectedRowsId && this.state.selectedRowsId.length > 0 && (
                    <Col span={5}>
                      <Button style={{ float: 'right', marginTop: 1, marginRight: 4 }} onClick={this.handleDeleteAll}>
                            Сонгогдсон барааг устгах
                      </Button>
                    </Col>)
                }
                <Col span={5}>
                  <Switch
                    checkedChildren="Зураггүй"
                    unCheckedChildren="Бүгд"
                    onChange={value => this.handleTableChange(1, this.props.filter.limit, value, 'no_image')}
                    style={{ float: 'right', marginTop: 1, marginRight: 4 }}
                  />
                </Col>
                <Col span={11}>
                  <RadioGroup defaultValue="1" onChange={event => this.handleTableChange(1, this.props.filter.limit, event.target.value, 'inactive')} style={{ float: 'right' }} size="small">
                    <RadioButton value="1"><span style={{ fontSize: 13 }}>Бүгд</span></RadioButton>
                    <RadioButton value="2"><span style={{ fontSize: 13 }}>Идэвхгүй</span></RadioButton>
                    <RadioButton value="3"><span style={{ fontSize: 13 }}>Идэвхтэй</span></RadioButton>
                  </RadioGroup>
                </Col>
              </Col>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 20 }}>
                <div style={{ width: '100%', float: 'left', marginBottom: 20 }}>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Input.Search
                        placeholder="Барааны нэрээр хайх.."
                        size="small"
                        value={this.props.filter.title}
                        onChange={event => this.handleTableChange(1, this.props.filter.limit, event.target.value, 'title')}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Cascader
                        array={this.props.categories}
                        valueKey="value"
                        labelKey="label"
                        size="small"
                        childrenKey="children"
                        placeholder="Категороор хайх"
                        style={{ width: '100%' }}
                        initialValue={this.props.filter.relation_id}
                        onChange={(value) => { console.log(value); this.handleTableChange(1, this.props.filter.limit, value, 'relation_id'); }}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div style={{ paddingRight: 10 }}>
                      <Input.Search
                        placeholder="Бар кодоор хайх"
                        size="small"
                        value={this.props.filter.barcode}
                        onChange={event => this.handleTableChange(1, this.props.filter.limit, event.target.value, 'barcode')}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <Input.Search
                      placeholder="Үлдэгдлээр хайх"
                      size="small"
                      value={this.props.filter.quantity}
                      onChange={event => this.handleTableChange(1, this.props.filter.limit, event.target.value, 'quantity')}
                    />
                  </Col>
                </div>
              </div>
            </Col>
          </Row>
          <Table
            className={styles.dataTable}
            rowKey={record => record.id}
            columns={this.columns}
            onChange={this.handleTableChange}
            rowSelection={this.rowSelection}
            dataSource={[...productList.data]}
            pagination={false}
            loading={productList.isLoading}
            scroll={{ x: 990 }}
          />
          <div style={{ marginTop: 20, float: 'right' }}>
            <Pagination
              defaultCurrent={1}
              onChange={this.handleTableChange}
              pageSize={this.props.filter.limit}
              total={this.props.productList.total}
              current={this.props.filter.offset + 1}
              size="small"
            />
          </div>
        </Card>
      </PageHeaderLayout>
    );
  }
}

ProductList.propTypes = {
  categories: PropTypes.array.isRequired,
  products: PropTypes.func.isRequired,
  productList: PropTypes.object,
  updateQuantity: PropTypes.func.isRequired,
  productDelete: PropTypes.func.isRequired,
  filterChange: PropTypes.func.isRequired,
  exportExcel: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  excel: PropTypes.object.isRequired,
};

ProductList.defaultProps = {
  productList: [],
};

const mapStateToProps = state => ({
  excel: state.product.excel,
  productList: state.product.all,
  indexedCategories: state.global.indexedCategories,
  categories: state.category.all.data,
  filter: state.filter,
});

export default connect(mapStateToProps, {
  products: Product.all,
  productDelete: Product.delete,
  updateQuantity: Product.updateQuantity,
  exportExcel: Product.exportExcel,
  filterChange: Filter.onChange,
  filterReset: Filter.reset,
})(ProductList);




// WEBPACK FOOTER //
// ./src/containers/Products/List/index.js